import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { InfoCircledIcon } from "@radix-ui/react-icons";

export function SecurityWarning() {
  return (
    <Alert className="mb-6">
      <InfoCircledIcon className="h-4 w-4" />
      <AlertTitle>API密钥使用说明</AlertTitle>
      <AlertDescription>
        此应用程序会将您的API密钥存储在浏览器的localStorage中，但所有API请求都通过后端服务器处理。
        API密钥不会在浏览器中直接用于API调用，但仍请确保不要在公共设备上使用此应用。
      </AlertDescription>
    </Alert>
  );
} 